<i
    [class]="iconClass()"
    [class.tooltip-disabled]="tooltipDisabled()"
    [class.info-tooltip]="true"
    tabindex="0"
    style="outline: 0"
    [id]="id() + '-tooltip'"
    [pTooltip]="text() | translate"
    [tooltipStyleClass]="styleClass()"
    [tooltipPosition]="position()"
    [tooltipDisabled]="tooltipDisabled()"
    [tooltipEvent]="''"
    [escape]="tooltipEscape()"
    (keyup.enter)="activateTooltip($event)"
    (focusout)="deactivateTooltip($event)"
    (click)="activateTooltip($event)"
    (mouseover)="activateTooltip($event)"
    (mouseout)="deactivateTooltip($event)"></i>
